// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Shipments_establishments__x191V","header":"Shipments_header__2kj5v","tableHeader":"Shipments_tableHeader__1_LRO"};